module.exports = __webpack_public_path__ + "img/avatar3.6cb2a2f3.png";